import clsx from 'clsx'
import {FC} from 'react'

type Props = {
  location: any
  handleSelect: (id: any) => void
  selectedLocation: string
  currentLocationId: string
}
const LocationListItem: FC<Props> = ({
  location,
  handleSelect,
  selectedLocation,
  currentLocationId,
}) => {
  return (
    <>
      <div
        className={clsx(
          'mb-4 border border-2 rounded-2 cursor-pointer',
          selectedLocation === location.id && currentLocationId !== location.id
            ? 'border-primary-active'
            : 'border-muted',
          currentLocationId === location.id && 'disabled'
        )}
        onClick={() => handleSelect(location.id)}
      >
        <div className='d-flex align-items-center m-4'>
          <div className='form-check form-check-custom me-5'>
            <input
              type='radio'
              className='form-check-2hx'
              checked={selectedLocation === location.id}
              disabled={currentLocationId === location.id}
            />
          </div>
          <span>{location.name}</span>
          <div className='d-flex w-100 justify-content-end'>
            {currentLocationId === location.id && (
              <span className=' badge badge-light '>Current Location</span>
            )}
          </div>
        </div>
      </div>
    </>
  )
}
export default LocationListItem
